import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import { webCampaign } from '@/modules/webCampaign';

import { PaywallUsersReviews } from '../../../../components/UsersReviews';

import {
  UsersReviewsStyles,
  UsersReviewsTitleStyles,
  UsersReviewsWrapperStyles,
} from './UsersReviews.styles';

export const SectionUsersReviews: React.FC = () => {
  const paywallNotes = webCampaign.setup.paywallNotes;
  const shouldShowStoreImages = paywallNotes?.includes(
    PAYWALL_NOTES.STORE_IMAGES,
  );

  return (
    <UsersReviewsStyles>
      <UsersReviewsTitleStyles>
        Trusted by{' '}
        <UiTypography variant="inherit" color="gradient" component="span">
          1,556,867
        </UiTypography>{' '}
        users
      </UsersReviewsTitleStyles>
      {shouldShowStoreImages && (
        <div className="store-images">
          <img src="/assets/googleplay.png" alt="googleplay" />
          <img src="/assets/appstore.png" alt="appstore" />
        </div>
      )}
      <UsersReviewsWrapperStyles>
        <PaywallUsersReviews />
      </UsersReviewsWrapperStyles>
    </UsersReviewsStyles>
  );
};
